<script lang="ts">
    import { Component } from 'vue-facing-decorator';
    import Vue from "vue";
    import { MonthPicker } from 'vue-month-picker';
    import { MonthYear, MonthYearHelpers } from '@common/types';
    import { MonthPickerDate, MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog';

    @Component(
        {
            props: {
                viewModel: {
                    type: Object,
                    required: true
                }
            },
            components: { MonthPicker }
        })
    export default class MonthPickerDialog extends Vue
    {
        get vm(): MonthPickerDialogViewModel { return this.$props.viewModel as MonthPickerDialogViewModel; }
        get opened(): boolean { return this.vm?.isOpened ?? false; }
        get title(): string { return this.vm.title; }
        get description(): string | null { return this.vm.description; }

        get defaultYear(): number | null { return this.vm.defaultDate?.Year ?? null; }
        get defaultMonth(): number  | null { return this.vm.defaultDate?.Month ?? null; }
        get canConfirm(): boolean { return this.vm.valueRequired === true ? this.date != null : true; }

        date: MonthPickerDate | null = null;

        onDateChange(date: MonthPickerDate) 
        {
            this.date = date;
        }

        onDateClear() 
        {
            this.date = null;
        }
        
        confirm()
        {
            const result = this.date == null ? null : MonthYearHelpers.build(this.date.year, this.date.monthIndex);
            
            this.$emit('update-date', result);

            this.close();
        }

        close()
        {
            this.vm.close();
            this.date = null;
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div v-if="description" class="alert alert-warning" role="alert">
                            {{description}}
                        </div>
                        <month-picker @clear="onDateClear" @change="onDateChange" 
                                      :clearable="true" 
                                      :no-default="vm.defaultDate == null"
                                      :default-month="defaultMonth" 
                                      :default-year="defaultYear" />
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="confirm" :disabled="canConfirm === false" type="button" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
    .month-picker__container {width: 100%;}
</style>